export default __webpack_public_path__ + "static/media/text-share.d352ea5d.svg";